import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Searchlien',
      component: () => import("@/components/Searchlien"),
    },
    {
      path: '/Accountdetail/:instId/:custId/:supplyType',
      name: 'Accountdetail',
      component: () => import("@/components/Accountdetail"),
    },
    {
      path: '/Liensdetail/:address/:userInput/:acctflag/:addressId',
      name: 'Liensdetail',
      component: () => import("@/components/Liensdetail"),
    },
  ],
});

export default router;
